import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormDetail } from "../../../../../redux/slice/form";
import { useHookForm } from "../../../../../components/hooks";

import { FormRadio } from "../../../../../components/formElement";
import {
  option_treatment_consider,
  option_5_score,
} from "../../../../../service/option";

import ImgQuestion from "../../../../../images/other/question_icon.PNG";

import { Button } from "primereact/button";

export default function ModuleTreatmentStep3(props) {
  const { onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  // 表單欄位預設值
  const defaultValues = {
    b1: null,
    b2: null,
    b3: null,
    b4: null,
    b5: null,
    b6: null,
    b7: null,
    b8: null,
    b9: null,
    b10: null,
  };
  const { handleSubmit, reset, yup, setSchema, setting } = useHookForm({
    defaultValues,
  });

  useEffect(() => {
    setSchema(
      yup
        .object({
          b1: yup.number().required("必填").nullable(),
          b2: yup.number().required("必填").nullable(),
          b3: yup.number().required("必填").nullable(),
          b4: yup.number().required("必填").nullable(),
          b5: yup.number().required("必填").nullable(),
          b6: yup.number().required("必填").nullable(),
          b7: yup.number().required("必填").nullable(),
          b8: yup.number().required("必填").nullable(),
          b9: yup.number().required("必填").nullable(),
          b10: yup.number().required("必填").nullable(),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    if (redux_form.formDetail?.step3) {
      reset(redux_form.formDetail.step3);
    }
  }, [redux_form]);

  const onSubmit = (submitData) => {
    let jsonData = {
      ...redux_form.formDetail,
      step3: submitData,
    };
    dispatch(setFormDetail(jsonData));

    onTabChange({ index: 3 });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="text-lg mt-34">
        <div className="flex align-items-center text-2xl font-bold mb-1">
          <img className="mr-2" src={ImgQuestion} alt="Question" />
          對於近視治療的考量?
        </div>

        <table className="w-full table-collapse">
          <tbody>
            <tr style={{ backgroundColor: "#ff9966" }}>
              <td className="border-1 border-500 p-1">考量項目</td>
              <td className="text-center border-1 border-500 p-1">
                毫不在意<i className="pi pi-arrow-left px-3"></i>在意程度
                <i className="pi pi-arrow-right px-3"></i>非常在意
              </td>
              <td className="border-1 border-500 p-1">
                備註：如果您非常在意這件事，建議您可以考慮選擇的方案
              </td>
            </tr>
            {option_treatment_consider.map((item, index) => (
              <tr
                key={item.value}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fbe5d6" : "#d8e9cd",
                }}
              >
                <td className="border-1 border-500 p-1">{item.label}</td>
                <td className="border-1 border-500 p-1">
                  <div className="flex flex-wrap justify-content-center">
                    {option_5_score.map((option) => (
                      <FormRadio
                        key={`score_${option.value}`}
                        setting={setting}
                        data={{
                          name: `b${index + 1}`,
                          label: option.label,
                          value: option.value,
                        }}
                      />
                    ))}
                  </div>
                </td>
                <td className="border-1 border-500 p-1">{item.remark}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="col-12 text-center my-3">
          <Button
            className="p-button-warning text-white px-3 rotate-icon-x-180"
            type="button"
            label="上一步：比較"
            icon="fa fa-reply bg-main border-round-md p-1"
            onClick={() => onTabChange({ index: 1 })}
          />
          <Button
            className="p-button-warning text-white ml-3 px-3 rotate-icon-xy-180 rotate-icon-y-180"
            type="submit"
            label="下一步：了解"
            icon="fa fa-reply bg-main border-round-md p-1"
          />
        </div>
      </form>
    </>
  );
}
